export const THUMB_SIZE = '80px';

export const THUMB_SIZE_MULTIPLE = '72px';
